// extracted by mini-css-extract-plugin
export default {"publish-variant-modal":"PublishVariantModal_publish-variant-modal__2U6DZ","title":"PublishVariantModal_title__KQcgk"};